<div class="flex flex-col h-full">
	<h2 class="mb-4">Property details</h2>
	<div class="flex mb-5" *ngIf="detailsUrl">
		<app-anchor type="tab" [url]="detailsUrl">Details</app-anchor>
		<!-- <app-anchor type="tab" [url]="complianceLettersUrl">Compliance letters</app-anchor> -->
		<app-anchor
			type="tab"
			[url]="condoCorpUrl"
			*ngIf="propertyType?.type === propertyTypes.CONDO"
			[@fade]
			>Condo corporation</app-anchor
		>
	</div>

	<div class="h-full">
		<router-outlet class="hidden-router"></router-outlet>
	</div>
</div>
